import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackSavedSearchItem = () => useTrackConversion({ goal: KameleoonGoalData.SavedSearchItem });
